/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActiveKioskConfigDto } from '../models/active-kiosk-config-dto';
import { kioskConfigControllerActivateV1 } from '../fn/kiosk-config/kiosk-config-controller-activate-v-1';
import { KioskConfigControllerActivateV1$Params } from '../fn/kiosk-config/kiosk-config-controller-activate-v-1';
import { kioskConfigControllerFindAllV1 } from '../fn/kiosk-config/kiosk-config-controller-find-all-v-1';
import { KioskConfigControllerFindAllV1$Params } from '../fn/kiosk-config/kiosk-config-controller-find-all-v-1';
import { kioskConfigControllerGetActiveV1 } from '../fn/kiosk-config/kiosk-config-controller-get-active-v-1';
import { KioskConfigControllerGetActiveV1$Params } from '../fn/kiosk-config/kiosk-config-controller-get-active-v-1';
import { kioskConfigControllerUpdateV1 } from '../fn/kiosk-config/kiosk-config-controller-update-v-1';
import { KioskConfigControllerUpdateV1$Params } from '../fn/kiosk-config/kiosk-config-controller-update-v-1';
import { KioskConfigDto } from '../models/kiosk-config-dto';
import { KioskConfigListDto } from '../models/kiosk-config-list-dto';

@Injectable({ providedIn: 'root' })
export class KioskConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `kioskConfigControllerGetActiveV1()` */
  static readonly KioskConfigControllerGetActiveV1Path = '/api/v1/kiosk-config/active';

  /**
   * 활성 키오스크 설정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kioskConfigControllerGetActiveV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerGetActiveV1$Response(params?: KioskConfigControllerGetActiveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ActiveKioskConfigDto>> {
    return kioskConfigControllerGetActiveV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 활성 키오스크 설정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kioskConfigControllerGetActiveV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerGetActiveV1(params?: KioskConfigControllerGetActiveV1$Params, context?: HttpContext): Observable<ActiveKioskConfigDto> {
    return this.kioskConfigControllerGetActiveV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActiveKioskConfigDto>): ActiveKioskConfigDto => r.body)
    );
  }

  /** Path part for operation `kioskConfigControllerFindAllV1()` */
  static readonly KioskConfigControllerFindAllV1Path = '/api/v1/kiosk-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kioskConfigControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerFindAllV1$Response(params?: KioskConfigControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigListDto>> {
    return kioskConfigControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kioskConfigControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerFindAllV1(params?: KioskConfigControllerFindAllV1$Params, context?: HttpContext): Observable<KioskConfigListDto> {
    return this.kioskConfigControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskConfigListDto>): KioskConfigListDto => r.body)
    );
  }

  /** Path part for operation `kioskConfigControllerUpdateV1()` */
  static readonly KioskConfigControllerUpdateV1Path = '/api/v1/kiosk-config/{sourceType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kioskConfigControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kioskConfigControllerUpdateV1$Response(params: KioskConfigControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigDto>> {
    return kioskConfigControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kioskConfigControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  kioskConfigControllerUpdateV1(params: KioskConfigControllerUpdateV1$Params, context?: HttpContext): Observable<KioskConfigDto> {
    return this.kioskConfigControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskConfigDto>): KioskConfigDto => r.body)
    );
  }

  /** Path part for operation `kioskConfigControllerActivateV1()` */
  static readonly KioskConfigControllerActivateV1Path = '/api/v1/kiosk-config/{sourceType}/activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kioskConfigControllerActivateV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerActivateV1$Response(params: KioskConfigControllerActivateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigDto>> {
    return kioskConfigControllerActivateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kioskConfigControllerActivateV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kioskConfigControllerActivateV1(params: KioskConfigControllerActivateV1$Params, context?: HttpContext): Observable<KioskConfigDto> {
    return this.kioskConfigControllerActivateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskConfigDto>): KioskConfigDto => r.body)
    );
  }

}
